import React from 'react';
import { TextField } from '@mui/material';

const TextareaInput = ({ label, value, onChange, rows='4' }) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      multiline
      rows={rows}
      InputLabelProps={{ shrink: true }} 
    />
  );
};

export default TextareaInput;